import { cn } from '@/lib/utils'
import { useUIStore } from '@/store/useUIStore'

import { DarkModeToggle } from '../ui/dark-mode-toggle'

/**
 * AppDarkModeToggle
 * App-specific wrapper for the shadcn/ui DarkModeToggle component.
 * Handles Zustand store, custom classes, and any app logic.
 */
export default function AppDarkModeToggle(props) {
  const theme = useUIStore(state => state.theme)
  const setTheme = useUIStore(state => state.setTheme)


  return (
    <DarkModeToggle
      theme={theme}
      setTheme={setTheme}
      className={props.className}
      {...props}
    />
  )
}
